// src/providers/reflection-provider.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React from "react";
var ReflectionContext = React.createContext({
  state: {},
  dispatch: /* istanbul ignore next -- @preserve */function () {}
});
var reflectionStateReducer = function (state, action) {
  var type = action.type;
  if (type === "UPDATE_DATES") {
    return _object_spread_props(_object_spread({}, state), {
      dates: _object_spread({}, action)
    });
  }
  if (type === "UPDATE_TRAVELERS") {
    return _object_spread_props(_object_spread({}, state), {
      travelers: _object_spread({}, action.travelers)
    });
  }
  if (type === "UPDATE_DATES_AND_TRAVELERS") {
    var _action_travelers, _state_travelers, _state_travelers1, _state_travelers2, _state_travelers3, _action_travelers1, _action_travelers2, _action, _state_dates, _action_travelers3, _action_travelers4, _action1, _state_dates1;
    return _object_spread_props(_object_spread({}, state), {
      travelers: ((_action_travelers = action.travelers) === null || _action_travelers === void 0 ? void 0 : _action_travelers.adultTravelerCounts) ? _object_spread({}, action.travelers) : _object_spread_props(_object_spread({}, action.travelers), {
        adultTravelerCounts: (_state_travelers = state.travelers) === null || _state_travelers === void 0 ? void 0 : _state_travelers.adultTravelerCounts,
        childTravelerCounts: (_state_travelers1 = state.travelers) === null || _state_travelers1 === void 0 ? void 0 : _state_travelers1.childTravelerCounts,
        childrenAges: (_state_travelers2 = state.travelers) === null || _state_travelers2 === void 0 ? void 0 : _state_travelers2.childrenAges,
        petCounts: (_state_travelers3 = state.travelers) === null || _state_travelers3 === void 0 ? void 0 : _state_travelers3.petCounts
      }),
      dates: {
        start: ((_action_travelers1 = action.travelers) === null || _action_travelers1 === void 0 ? void 0 : _action_travelers1.startDate) ? new Date((_action = action) === null || _action === void 0 ? void 0 : (_action_travelers2 = _action.travelers) === null || _action_travelers2 === void 0 ? void 0 : _action_travelers2.startDate).toISOString().split("T")[0] : (_state_dates = state.dates) === null || _state_dates === void 0 ? void 0 : _state_dates.start,
        end: ((_action_travelers3 = action.travelers) === null || _action_travelers3 === void 0 ? void 0 : _action_travelers3.endDate) ? new Date((_action1 = action) === null || _action1 === void 0 ? void 0 : (_action_travelers4 = _action1.travelers) === null || _action_travelers4 === void 0 ? void 0 : _action_travelers4.endDate).toISOString().split("T")[0] : (_state_dates1 = state.dates) === null || _state_dates1 === void 0 ? void 0 : _state_dates1.end
      }
    });
  }
  var location = action.location;
  return _object_spread_props(_object_spread({}, state), _define_property({}, type === "UPDATE_DESTINATION" ? "destination" : "origin", location));
};
var SearchFormReflectionProvider = function (props) {
  var children = props.children;
  var _React_useReducer = _sliced_to_array(React.useReducer(reflectionStateReducer, {}), 2),
    state = _React_useReducer[0],
    dispatch = _React_useReducer[1];
  var value = React.useMemo(function () {
    return {
      state: state,
      dispatch: dispatch
    };
  }, [state]);
  return /* @__PURE__ */React.createElement(ReflectionContext.Provider, {
    value: value
  }, children);
};
var useSearchFormReflectionContext = function () {
  return React.useContext(ReflectionContext);
};
export { SearchFormReflectionProvider, useSearchFormReflectionContext };